import NotesBlock from '@/components/notes/notes-block';
import { ScrollArea } from '@/components/ui/scroll-area';
import { groupNoteBlocksByDay } from '@/lib/notes/notes-helpers';

/**
 * The scrolling stream: newest-first blocks grouped under TODAY / YESTERDAY / weekday
 * separators on the dot-grid "rough paper" texture.
 */
function NotesStream({ blocks, onToggleItem, onDelete, emptyHint }) {
  const groups = groupNoteBlocksByDay(blocks);
  return (
    <ScrollArea className="chat-pane-texture min-h-0 flex-1 border-t border-border">
      <div className="flex flex-col gap-2 px-3 pb-3 pt-2">
        {groups.map((group) => (
          <div key={group.key} className="flex flex-col gap-2">
            <div className="flex items-center gap-2 px-0.5 pt-1">
              <span className="text-[10px] font-black uppercase tracking-[0.1em] text-muted-foreground">
                {group.label}
              </span>
              <span className="h-px min-w-4 flex-1 bg-border" aria-hidden />
              {group.dateLabel ? (
                <span className="font-mono text-[10px] text-muted-foreground/80">{group.dateLabel}</span>
              ) : null}
            </div>
            {group.blocks.map((block) => (
              <NotesBlock key={block.id} block={block} onToggleItem={onToggleItem} onDelete={onDelete} />
            ))}
          </div>
        ))}
        {groups.length === 0 && emptyHint ? (
          <p className="px-1 pt-3 text-center text-xs text-muted-foreground">{emptyHint}</p>
        ) : null}
      </div>
    </ScrollArea>
  );
}

export default NotesStream;
